module.exports = __webpack_public_path__ + "img/stackslash-74.19bf679e.jpg";